import { all } from "redux-saga/effects"
import { authSaga } from "./authSaga"
import { categorySourceSaga } from "./categorySourceSagas"
import { appConfigSaga } from "./common/appConfigSaga"
import { dictionarySaga } from "./dictionarySagas"
import { localizedResourceSaga } from "./localized-resource/localizedResourcsSaga"
import { notifySaga } from "./notify/notifySaga"
import { uploadSaga } from "./upload-file/uploadSaga"
import { lopSaga } from "./danh-muc/lopSaga"
import { thoiKhoaBieuSaga } from "./thoi-khoa-bieu/thoiKhoaBieuSaga"
import { tuanSaga } from "./danh-muc/tuanSaga"
import { phongNamHocSaga } from "./danh-muc/phongNamHocSaga"
import { tietSaga } from "./danh-muc/tietSaga"
import { thoiKhoaBieuChiTietSaga } from "./thoi-khoa-bieu/thoiKhoaBieuChiTietSaga"
import { diemDanhSaga } from "./diem-danh/diemDanhSaga"
import { diemDanhTrangThaiSaga } from "./danh-muc/diemDanhTrangThaiSaga"

export default function* rootSaga() {
  yield all([
    authSaga(),
    dictionarySaga(),
    categorySourceSaga(),
    uploadSaga(),
    notifySaga(),
    localizedResourceSaga(),
    appConfigSaga(),
    lopSaga(),
    tuanSaga(),
    thoiKhoaBieuSaga(),
    thoiKhoaBieuChiTietSaga(),
    phongNamHocSaga(),
    tietSaga(),
    diemDanhSaga(),
    diemDanhTrangThaiSaga(),
  ]);
}
